function createCache() {
    const cache = {};
    return {
        has: (key) => Object.hasOwnProperty.call(cache, key),
        get: (key) => cache[key],
        set: (key, value) => {
            cache[key] = value;
        },
    };
}
export function memoize(cacheKeyFn, fn) {
    const cache = createCache();
    return (...args) => {
        const key = cacheKeyFn(...args);
        if (!cache.has(key)) {
            cache.set(key, fn(...args));
        }
        return cache.get(key);
    };
}
